var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _g2, _path13;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgNu = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 512 512"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#ffda44",
  d: "M0 85.334h512v341.337H0z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#f0f0f0",
  d: "M0 85.334h256v170.663H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#d80027"
}, /*#__PURE__*/React.createElement("path", {
  d: "M144 85.33h-32v69.333H0v32h112v69.334h32v-69.334h112v-32H144z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 85.329v15.083l57.377 38.251H80z"
}))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
  fill: "#2e52b2"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 85.329v15.083l-57.377 38.251H176z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
  fill: "#2e52b2"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 85.329v15.083l57.377 38.251H80z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M0 107.951v30.712h46.069zm96-22.62v48.913L22.628 85.331z",
  fill: "#2e52b2"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 85.329v15.083l-57.377 38.251H176z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M256 107.951v30.712h-46.069zm-96-22.62v48.913l73.372-48.913z",
  fill: "#2e52b2"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M0 255.997v-15.082l57.377-38.252H80z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  d: "M0 233.376v-30.713h46.069zm96 22.618v-48.912l-73.372 48.912z",
  fill: "#2e52b2"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#d80027",
  d: "M256 255.997v-15.082l-57.377-38.252H176z"
})), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  fill: "#2e52b2"
}, /*#__PURE__*/React.createElement("path", {
  d: "M256 233.376v-30.713h-46.069zm-96 22.618v-48.912l73.372 48.912z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 128,
  cy: 170.66,
  r: 22.627
}))), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  d: "M128 154.663l3.97 12.222h12.854l-10.398 7.556 3.971 12.222L128 179.109l-10.398 7.554 3.972-12.222-10.398-7.556h12.853zm0 65.14l2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm0-117.334l2.364 7.278h7.653l-6.19 4.498 2.364 7.278-6.191-4.498-6.191 4.498 2.364-7.278-6.19-4.498h7.652zm69.931 58.667l2.365 7.277h7.653l-6.192 4.499 2.365 7.279-6.191-4.498-6.191 4.498 2.365-7.279-6.191-4.499h7.652zm-139.862 0l2.364 7.277h7.653l-6.191 4.499 2.364 7.279-6.19-4.498-6.191 4.498 2.365-7.279-6.192-4.499h7.653z",
  fill: "#ffda44"
})));

export default SvgNu;